// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Gets client parameters from an Account Connection String
 * Only supported in Node.js not supported for Browsers
 * @param _extractedCreds - parsed connection string
 * @param _options - TablesServiceClient options
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
export function fromAccountConnectionString(_connectionString, _options) {
    throw new Error("Account connection string is only supported in Node.js environment");
}
export function getAccountConnectionString(_accountName, _accountKey, _defaultEndpointsProtocol, _endpointSuffix, _tableEndpoint) {
    throw new Error("Account connection string is only supported in Node.js environment");
}
//# sourceMappingURL=accountConnectionString.browser.js.map